import { useState, useEffect } from 'react'
import useI18n from 'src/hooks/useI18n'
import CheckIcon from 'src/static/icons/ico_check.svg'

interface Props {
  option: Array<Number>;
  filteredMinPrice: Number;
  filteredMaxPrice: Number;
  formatNumber: Function;
  setFilteredMinPrice(min: Number): void;
  setFilteredMaxPrice(max: Number): void;
  filterOnClick: boolean;
}

const ListValue = (props: Props) => {
  const {
    option,
    filteredMinPrice,
    filteredMaxPrice,
    formatNumber,
    setFilteredMinPrice,
    setFilteredMaxPrice
  } = props

  const [selected, setSelected] = useState((+filteredMinPrice === option[0] && +filteredMaxPrice === option[1]))

  const handlesFilter = async (min: Number, max: Number) => {
    if (selected) {
      // Valores abaixo de 0 removem o parâmetro do filtro
      setFilteredMinPrice(-1)
      setFilteredMaxPrice(-1)
    } else {
      setFilteredMinPrice(min)
      setFilteredMaxPrice(max)
    }
    setSelected(!selected)
  }

  useEffect(() => {
    if ((filteredMinPrice !== null && filteredMinPrice !== undefined) && (filteredMinPrice !== null && filteredMinPrice !== undefined)) {
      setSelected(+filteredMinPrice === option[0] && +filteredMaxPrice === option[1])
    }
  }, [filteredMinPrice, filteredMaxPrice])

  const translation = useI18n()

  return (
    <div
    className={`list-value-container ${selected ? 'label-selected' : ''}`}
    onClick={() => handlesFilter(option[0], option[1])}
  >
    <div className="list-value-image">
      {selected && <img src={CheckIcon}/>}
    </div>
    <div className="list-value-text">
      <span>{formatNumber(option[0]) + ` ${translation.filter.to} ` + formatNumber(option[1])}</span>
    </div>
  </div>
  )
}

export default ListValue
